import styles from "./HelpSection.module.scss";

const HelpSection = () => (
  <p className={styles.help}>
    Precisa de ajuda? <a href="https://afinandoocerebro.zohodesk.com/portal/pt-br/kb" target="_blank" rel="noopener noreferrer">Acesse nosso suporte</a>
  </p>
);

export default HelpSection;